import { Injectable, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { oofDtos } from '@vectronic/openApi-customer';
import { OrderStatusMapper } from '@vectronic/shared/oof/data-access';
import { AutocompleteItem } from '@vectronic/ui';
import { filter, map } from 'rxjs';
import { UsersService } from './users.service';

interface AutocompleteOptionsState {
  salesOptions: AutocompleteItem[];
  salesOptionsLoaded: boolean;
}
@Injectable({ providedIn: 'root' })
export class AutocompleteOptionsService {
  private usersService = inject(UsersService);

  //state
  private state = signal<AutocompleteOptionsState>({
    salesOptions: [],
    salesOptionsLoaded: false,
  });

  // selectors
  salesOptions = computed(() => this.state().salesOptions);
  salesOptionsLoaded = computed(() => this.state().salesOptionsLoaded);
  salesFilterOptions = computed(() => [
    {
      value: 'ALL',
      label: 'ALL',
    },
    {
      value: 'UNASSIGNED',
      label: 'UNASSIGNED',
    },
    {
      value: 'ASSIGNED',
      label: 'ASSIGNED',
    },
    ...this.salesOptions(),
  ]);
  orderStatus = computed(() =>
    Object.entries(oofDtos.Order.StatusEnum)
      .map(([, orderStatus]) => ({
        value: orderStatus,
        label: OrderStatusMapper.getTitle(orderStatus),
      }))
      .sort((a, b) => a.value.localeCompare(b.value)),
  );

  // sources
  private salesOptionsLoaded$ = toObservable(this.usersService.sales).pipe(
    filter((users) => users?.length > 0),
    map((users) =>
      users.map((user) => ({
        value: user.email,
        label: `${user.initials} / ${user.firstName} ${user.lastName}`,
      })),
    ),
  );

  constructor() {
    // reducers
    this.salesOptionsLoaded$.pipe(takeUntilDestroyed()).subscribe((salesOptions) =>
      this.state.update((state) => ({
        ...state,
        salesOptions: salesOptions,
        salesOptionsLoaded: true,
      })),
    );
    // effects
  }
}
